import { courseNameList, courseDocumentList, courseList,courseRatingsList, channelPartnerEnrolledCourseList,channelPartnerCoursePendingEnrolledList, enrolledChannelPartnerListAgainstCourse} from "constants/course";


const initialState = {
  courseNameList: {},
  courseDocumentList: {},
  courseList: {},
  courseRatingsList: {},
  channelPartnerEnrolledCourseList : {},
  channelPartnerCoursePendingEnrolledList :{},
  enrolledChannelPartnerListAgainstCourse : {}
};

const course = (state = initialState, action) => {
  switch (action.type) {
    case courseNameList:
      return { ...state, courseNameList: action.payload };

    case courseDocumentList:
      return { ...state, courseDocumentList: action.payload };

    case courseList:
      return { ...state, courseList: action.payload };

    case courseRatingsList:
      return { ...state, courseRatingsList: action.payload };

    case channelPartnerEnrolledCourseList:
      return { ...state, channelPartnerEnrolledCourseList: action.payload };  
    
    case channelPartnerCoursePendingEnrolledList:
      return { ...state, channelPartnerCoursePendingEnrolledList: action.payload };  
    
    case enrolledChannelPartnerListAgainstCourse:
      return { ...state, enrolledChannelPartnerListAgainstCourse: action.payload };  

    default:
      return state;
  }
};

export default course;